import Home from '@/views/home/index';
import Dashboard from '@/views/home/dashboard/Dashboard';
import Account from '@/views/home/account/Account';
import CreateAccount from '@/views/home/account/CreateAccount';
import RouteLocation from './RouteLocation';
import RouteAttraction from './RouteAttraction';
import RoutePackage from './RoutePackage';
// import router from '@/routers';
import auth from '@/routers/middlewares/auth';
import superadmin from '@/routers/middlewares/superadmin';

export default [{
    path: '/home',
    name: 'index-home',
    component: Home,
    redirect: '/home/account',
    meta: {
        middleware: [auth, superadmin]
    },
    children: [
        ...RouteAttraction,
        ...RouteLocation,
        ...RoutePackage,
        {
            path: '/home/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                middleware: [auth, superadmin]
            }
        },
        {
            path: '/home/account',
            name: 'Account',
            component: Account,
            meta: {
                middleware: [auth, superadmin]
            }
        },
        {
            path: '/home/account/create',
            name: 'Create Account',
            component: CreateAccount,
            meta: {
                middleware: [auth, superadmin]
            }
        },
        {
            path: '/home/account/edit/:id',
            name: 'Edit Account',
            component: CreateAccount,
            meta: {
                middleware: [auth, superadmin]
            }
        }
    ]
}];